<template>
  <div v-if="session">
    <card class="basicCard">
      <div class="row">
        <div class="col-sm-5">
          <div class="customCard bottomLine" id="referenceDiv">
            <div class="row">
              <div class="col-sm-8">
                <h5 class="cardTitles">Overall</h5>
                <h1>Risk Score</h1>
              </div>
              <div class="col-sm-4 text-center">
                <h1 :class="calculateRiskColor(session.riskScore)">
                  {{ session.riskScore }}
                </h1>
              </div>
              <div class="col-sm-12">
                <br />
                <div class="row barLabels">
                  <div class="col-sm-6">
                    <h5 class="barLabels">0</h5>
                  </div>
                  <div class="col-sm-6">
                    <h5 style="float: right" class="barLabels">100</h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="riskLevel text-center" id="targetDiv">
              <h5>{{ session.riskScore }}</h5>
              <h2>▼</h2>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-sm-2"></div>
            <div class="col-sm-8">
              <div class="valueBoxes">
                <b>Status:</b>
                <span class="floatRight align-items-center">
                  {{ session.status }}
                  <el-icon
                    v-if="session.status === 'Approved'"
                    name="success filled"
                    class="icon-green"
                  ></el-icon>
                  <el-icon
                    v-else-if="session.status === 'Pending'"
                    name="loading"
                    class="icon-orange"
                  ></el-icon>
                  <el-icon
                    v-else-if="session.status === 'Rejected'"
                    name="close"
                    class="icon-red"
                  ></el-icon>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-7">
          <h1 class="normalH1">{{ session.name }}</h1>
          <div class="row">
            <div class="col-sm-4 align-items-center">
              <h5 class="cardTitles">Completed By: {{ student.full_name }}</h5>
            </div>
            <div class="col-sm-4 align-items-center">
              <h5 class="cardTitles">
                Date: {{ session.date.toLocaleDateString() }}
              </h5>
            </div>
            <div class="col-sm-4 text-center">
              <h5 class="cardTitles borderedBox">
                Aircraft Number: {{ aircraft.aircraftNumber }}
              </h5>
            </div>
            <div class="col-sm-12">
              <el-button class="docsButton" style="text-align: center"
                >Submit Documentation<el-icon
                  name="camera"
                  class="camera"
                ></el-icon
              ></el-button>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-sm-6">
              <div class="borderedBox">
                <div class="row">
                  <div class="col-sm-6">
                    <h5 class="cardTitles">Take-off Weight*</h5>
                  </div>
                  <div class="col-sm-6">
                    <div class="valueBoxes">
                      {{ insertCommas(aircraft.takeOffWeight) }}lbs
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <h5 class="cardTitles">CG*</h5>
                  </div>
                  <div class="col-sm-6">
                    <div class="valueBoxes">
                      {{ insertCommas(aircraft.takeOffCG) }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <h5 class="cardTitles">Moment*</h5>
                  </div>
                  <div class="col-sm-6">
                    <div class="valueBoxes">
                      {{ insertCommas(aircraft.takeOffMoment) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="borderedBox">
                <div class="row">
                  <div class="col-sm-6">
                    <h5 class="cardTitles">Landing Weight*</h5>
                  </div>
                  <div class="col-sm-6">
                    <div class="valueBoxes">
                      {{ insertCommas(aircraft.landingWeight) }}lbs
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <h5 class="cardTitles">CG*</h5>
                  </div>
                  <div class="col-sm-6">
                    <div class="valueBoxes">
                      {{ insertCommas(aircraft.landingCG) }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <h5 class="cardTitles">Moment*</h5>
                  </div>
                  <div class="col-sm-6">
                    <div class="valueBoxes">
                      {{ insertCommas(aircraft.landingMoment) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div
          class="align-content-center"
          v-for="letter of pave"
          v-bind:key="letter.letter"
        >
          <div class="selectedLetter" v-if="letter.current">
            {{ letter.letter }}
          </div>
          <div @click="changePave(letter.letter)" class="paveLetter" v-else>
            {{ letter.letter }}
          </div>
        </div>
      </div>
      <div class="row" v-if="pave[0].current">
        <div class="col-sm-6">
          <h2>IMSAFE</h2>
          <br />
          <div class="row" v-for="item of imsafe" :key="item.id">
            <div class="col-sm-1 align-content-center">
              <el-button class="checkButton" @click="toggleItemState(item)">
                <el-icon
                  :name="'success filled'"
                  :class="item.selected ? 'icon-green' : 'icon-invisible'"
                ></el-icon>
              </el-button>
            </div>
            <div class="col-sm-11">
              <h5 class="listItems">{{ item.text }}</h5>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <h2>Currency / Proficiency</h2>
          <br />
          <div class="row" v-for="item of currencyProficiency" :key="item.id">
            <div class="col-sm-1 align-content-center">
              <el-button class="checkButton" @click="toggleItemState(item)">
                <el-icon
                  :name="'success filled'"
                  :class="item.selected ? 'icon-green' : 'icon-invisible'"
                ></el-icon>
              </el-button>
            </div>
            <div class="col-sm-11">
              <h5 class="listItems">{{ item.text }}</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="pave[1].current">
        <div class="col-sm-12">
          <h2>Documents - ARROWPEC</h2>
          <br />
          <div class="row">
            <div class="col-sm-6" v-for="item of arropecDoc" :key="item.id">
              <div class="row">
                <div class="col-sm-1 align-content-center">
                  <el-button class="checkButton" @click="toggleItemState(item)">
                    <el-icon
                      :name="'success filled'"
                      :class="item.selected ? 'icon-green' : 'icon-invisible'"
                    ></el-icon>
                  </el-button>
                </div>
                <div class="col-sm-11">
                  <h5 class="listItems">{{ item.text }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <h2>Inspections - AAV1ATES</h2>
          <br />
          <div class="row">
            <div
              class="col-sm-12"
              v-for="item of aac1atesInspection"
              :key="item.id"
            >
              <div class="row">
                <div class="col-sm-6">
                  <div class="row">
                    <div class="col-sm-1 align-content-center">
                      <el-button
                        class="checkButton"
                        @click="toggleItemState(item)"
                      >
                        <el-icon
                          :name="'success filled'"
                          :class="
                            item.selected ? 'icon-green' : 'icon-invisible'
                          "
                        ></el-icon>
                      </el-button>
                    </div>
                    <div class="col-sm-11">
                      <h5 class="listItems">{{ item.text }}</h5>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 displayFlex">
                  <h5 class="listItems greyBorder">
                    Date: <el-icon name="date" class="icon-grey"></el-icon>
                    {{ item.date.toLocaleDateString() }}
                  </h5>
                  <h5 class="listItems greyBorder greyBackground">
                    Days: {{ calculateDaysSince(item.date) }} Days
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <h2>Airworthiness Directives</h2>
          <br />
          <div class="row">
            <div
              class="col-sm-12"
              v-for="item of airworthinessDirectives"
              :key="item.id"
            >
              <div class="row">
                <div class="custom-col-sm-1 align-content-center">
                  <el-button class="checkButton" @click="toggleItemState(item)">
                    <el-icon
                      :name="'success filled'"
                      :class="item.selected ? 'icon-green' : 'icon-invisible'"
                    ></el-icon>
                  </el-button>
                </div>
                <div class="col-sm-11">
                  <h5 class="listItems">
                    {{ item.text }}
                    <a
                      v-if="item.id === 'list'"
                      href="http://www.faa.gov/regulations_policies/airworthiness_directives"
                    >
                      http://www.faa.gov/regulations_policies/airworthiness_directives
                    </a>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <h2>Inoperative Equipment</h2>
          <br />
          <div class="row">
            <div
              class="col-sm-12"
              v-for="item of inoperativeEquipment"
              :key="item.id"
            >
              <div class="row">
                <div class="custom-col-sm-1 align-content-center">
                  <el-button class="checkButton" @click="toggleItemState(item)">
                    <el-icon
                      :name="'success filled'"
                      :class="item.selected ? 'icon-green' : 'icon-invisible'"
                    ></el-icon>
                  </el-button>
                </div>
                <div class="col-sm-11">
                  <h5 class="listItems">
                    {{ item.text }}
                    <button class="navyButton" v-if="item.id === 'list'">
                      New Squawk
                    </button>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="pave[2].current">
        <div class="col-sm-12">
          <h2>NWKRAFT</h2>
          <br />
          <div class="row">
            <div class="col-sm-12" v-for="item of nwkraft" v-bind:key="item.id">
              <div class="row">
                <div class="col-sm-12">
                  <div class="row">
                    <div class="custom-col-sm-1 align-content-center">
                      <el-button
                        class="checkButton"
                        @click="toggleItemState(item)"
                      >
                        <el-icon
                          :name="'success filled'"
                          :class="
                            item.selected ? 'icon-green' : 'icon-invisible'
                          "
                        ></el-icon>
                      </el-button>
                    </div>
                    <div class="col-sm-11">
                      <h5 class="listItems">
                        {{ item.text }}
                        <button class="navyButton" v-if="item.id === 'list'">
                          New Squawk
                        </button>
                      </h5>
                    </div>
                    <div class="col-sm-12" v-if="item.id === 'NOTAMS'">
                      <div class="row">
                        <div class="custom-col-sm-1"></div>
                        <div class="col-sm-7">
                          <textarea
                            v-model="notams"
                            rows="3"
                            placeholder="Enter NOTAMS"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12" v-if="item.id === 'weather'">
                      <div class="row">
                        <div class="custom-col-sm-1"></div>
                        <div class="col-sm-10">
                          <table class="weather-chart">
                            <thead>
                              <tr>
                                <th colspan="9" class="chart-header">
                                  Weather Chart
                                </th>
                              </tr>
                              <tr>
                                <th>Location</th>
                                <th>Time</th>
                                <th>Wind</th>
                                <th>Visibility</th>
                                <th>Weather</th>
                                <th>Sky</th>
                                <th>Temp</th>
                                <th>Dew Point</th>
                                <th>Altimeter</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="entry of weatherChart"
                                v-bind:key="entry.id"
                              >
                                <td class="highlight">{{ entry.location }}</td>
                                <td>
                                  {{
                                    entry.time.getHours() +
                                    ":" +
                                    entry.time.getMinutes()
                                  }}
                                  Z
                                </td>
                                <td class="highlight">{{ entry.wind }}</td>
                                <td>{{ entry.visibility }}</td>
                                <td>{{ entry.weather }}</td>
                                <td>{{ entry.sky }}</td>
                                <td class="highlight">{{ entry.temp }}°</td>
                                <td>{{ entry.dewPoint }}</td>
                                <td>{{ entry.altimeter }}</td>
                              </tr>
                            </tbody>
                          </table>
                          <textarea
                            v-model="forecast"
                            rows="3"
                            placeholder="Forecast Weather (TAF) (FA) Enter FW Info Here"
                          />
                          <h5 class="listItems">Winds Aloft (FD)</h5>
                          <div class="row">
                            <div
                              class="col-sm-4"
                              v-for="(station, stationIndex) of stations"
                              v-bind:key="station.id"
                            >
                              <div class="row">
                                <div class="col-sm-3">
                                  <h5 class="listItems">Station</h5>
                                </div>
                                <div class="col-sm-8 align-content-center">
                                  <el-input
                                    v-model="station.name"
                                    placeholder="Enter Station Name"
                                    class="stationField"
                                  ></el-input>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-sm-3">
                                  <h5 class="listItems">3000'</h5>
                                </div>
                                <div class="col-sm-8 align-content-center">
                                  <el-input
                                    v-model="station.threeK"
                                    placeholder="Enter Wind at 3000'"
                                    class="stationField"
                                  ></el-input>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-sm-3">
                                  <h5 class="listItems">6000'</h5>
                                </div>
                                <div class="col-sm-8 align-content-center">
                                  <el-input
                                    v-model="station.sixK"
                                    placeholder="Enter Wind at 6000'"
                                    class="stationField"
                                  ></el-input>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-sm-3">
                                  <h5 class="listItems">9000'</h5>
                                </div>
                                <div class="col-sm-8 align-content-center">
                                  <el-input
                                    v-model="station.nineK"
                                    placeholder="Enter Wind at 9000'"
                                    class="stationField"
                                  ></el-input>
                                </div>
                              </div>
                              <div
                                class="row"
                                style="padding: 5px"
                                v-for="(
                                  elevation, index
                                ) of station.customElevations"
                                v-bind:key="elevation.elevation"
                              >
                                <div class="col-sm-3">
                                  <el-input
                                    v-model="elevation.elevation"
                                    placeholder="Elevation"
                                  ></el-input>
                                </div>
                                <div class="col-sm-8 align-content-center">
                                  <el-input
                                    v-model="elevation.value"
                                    placeholder="Value"
                                  ></el-input>
                                </div>
                                <div class="col-sm-1">
                                  <el-button
                                    type="text"
                                    @click="
                                      removeCustomAltitude(stationIndex, index)
                                    "
                                    class="remove-button"
                                  >
                                    <el-icon
                                      name="close"
                                      class="icon-red remove-icon"
                                    ></el-icon>
                                  </el-button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <button class="navyButton" @click="addCustomAltitude">
                            Add Custom Elevation
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12" v-if="item.id === 'atcDelays'">
                      <div class="row">
                        <div class="custom-col-sm-1"></div>
                        <div class="col-sm-7">
                          <textarea
                            v-model="notams"
                            rows="3"
                            placeholder="Enter Known ATC Delays"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12" v-if="item.id === 'runwayLengths'">
                      <div class="row">
                        <div class="custom-col-sm-1"></div>
                        <div
                          class="col-sm-3"
                          v-for="(length, index) of runwayLengths"
                          :key="index"
                          style="position: relative"
                        >
                          <div
                            v-if="index !== 0"
                            class="position-absolute top-left"
                          >
                            <el-button
                              type="text"
                              @click="removeRunwayLength(index)"
                              class="remove-button"
                            >
                              <el-icon
                                name="close"
                                class="icon-red remove-icon"
                              ></el-icon>
                            </el-button>
                          </div>
                          <div class="listValues">
                            Dep
                            <span
                              ><el-input
                                v-model="length.dep"
                                placeholder="Enter Dep"
                            /></span>
                            <span>ft</span>
                          </div>
                          <div class="listValues">
                            Dest
                            <span
                              ><el-input
                                v-model="length.dest"
                                placeholder="Enter Dest"
                            /></span>
                            <span>ft</span>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="custom-col-sm-1"></div>
                        <div class="col-sm-11">
                          <button class="navyButton" @click="addRunwayLength">
                            Add Set
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12" v-if="item.id === 'alternates'">
                      <div class="row">
                        <div class="custom-col-sm-1"></div>
                        <div
                          class="col-sm-2 align-items-center"
                          v-for="(alt, index) of alternatives"
                          v-bind:key="alt.name"
                          style="position: relative"
                        >
                          <div
                            v-if="index !== 0"
                            class="position-absolute top-left"
                          >
                            <el-button
                              type="text"
                              @click="removeAlternative(index)"
                              class="remove-button"
                            >
                              <el-icon
                                name="close"
                                class="icon-red remove-icon"
                              ></el-icon>
                            </el-button>
                          </div>
                          <div
                            v-if="alternatives.indexOf(alt) === 0"
                            style="width: 100%"
                          >
                            <div class="listValues">
                              Dest <span>{{ alt.name }}</span>
                            </div>
                          </div>
                          <div v-else>
                            <div class="listValues align-items-center">
                              Dest
                              <span
                                ><el-input
                                  v-model="alt.name"
                                  style="width: 90%"
                                ></el-input
                              ></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="custom-col-sm-1"></div>
                        <div class="col-sm-11">
                          <button class="navyButton" @click="addAlternative">
                            Add Alt.
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12" v-if="item.id === 'fuel'">
                      <div class="row">
                        <div class="custom-col-sm-1"></div>
                        <div class="col-sm-2">
                          <div class="listValues">
                            GAL Req. <span>{{ session.galReq }}</span>
                          </div>
                        </div>
                        <div class="col-sm-2">
                          <div class="listValues">
                            GAL On Board <span>{{ aircraft.galOnBoard }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12" v-if="item.id === 'takeOffLandDis'">
                      <div
                        v-for="(flight, index) of flights"
                        :key="flight.name"
                        style="position: relative"
                      >
                        <div class="row">
                          <div class="custom-col-sm-1"></div>
                          <div class="col-sm-2">
                            <div class="listValues">
                              Dep
                              <span
                                ><el-input
                                  v-model="flight.dep"
                                  style="width: 50%"
                                ></el-input
                                >ft</span
                              >
                            </div>
                          </div>
                          <div class="col-sm-2">
                            <div class="listValues">
                              Dest
                              <span
                                ><el-input
                                  v-model="flight.dest"
                                  style="width: 50%"
                                ></el-input
                                >ft</span
                              >
                            </div>
                          </div>
                          <div
                            class="col-sm-1"
                            v-if="index !== 0"
                            style="margin-left: -150px"
                          >
                            <el-button
                              type="text"
                              @click="removeFlight(index)"
                              class="remove-button"
                            >
                              <el-icon
                                name="close"
                                class="icon-red remove-icon"
                              ></el-icon>
                            </el-button>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="custom-col-sm-1"></div>
                        <div class="col-sm-11">
                          <button class="navyButton" @click="addFlight">
                            Add Flight
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="pave[3].current">
        <div class="col-sm-6">
          <h2>External Factors / Emotion</h2>
          <br />
          <div class="row" v-for="item of externalFactors" v-bind:key="item.id">
            <div class="col-sm-1 align-content-center">
              <el-button class="checkButton" @click="toggleItemState(item)">
                <el-icon
                  :name="'success filled'"
                  :class="item.selected ? 'icon-green' : 'icon-invisible'"
                ></el-icon>
              </el-button>
            </div>
            <div class="col-sm-11">
              <h5 class="listItems">{{ item.text }}</h5>
            </div>
          </div>
        </div>
      </div>
      <el-button class="lightGreyButton" @click="moveToNextPAVE"
        >Submit</el-button
      >
           <DispatchPopup :isVisible="true" />
<!--      <coming-soon-modal />-->
    </card>
  </div>
</template>
<script>
import { Button, Icon, Input, Table, TableColumn } from "element-ui";
//import ComingSoonModal from "@/components/HiloComponents/ComingSoonModal.vue";
 import DispatchPopup from "@/components/HiloComponents/DispatchPopup.vue";

export default {
  components: {
    DispatchPopup,
    //ComingSoonModal,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Input.name]: Input,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    cssVars() {
      return {
        "--riskLoc": 40 + (395 - 40) * (this.session.riskScore / 100) + "px",
      };
    },
  },
  data() {
    return {
      session: null,
      session_id: null,
      student: null,
      aircraft: null,
      pave: [
        { letter: "P", current: true },
        { letter: "A", current: false },
        { letter: "V", current: false },
        { letter: "E", current: false },
      ],
      imsafe: [
        { id: "illness", selected: false, text: "Illness - No Symptoms" },
        {
          id: "medication",
          selected: false,
          text: "Medication - No Unapproved Drugs",
        },
        { id: "stress", selected: false, text: "Stress - No Outside Worries" },
        {
          id: "alcohol",
          selected: false,
          text: "Alcohol - 8 hrs/not under influence",
        },
        {
          id: "fatigue",
          selected: false,
          text: "Fatigue - Well Rested, Not Tired",
        },
        { id: "emotions", selected: false, text: "Emotions - Not upset/angry" },
      ],
      currencyProficiency: [
        {
          id: "last2Weeks",
          selected: false,
          text: "Flown within last 2 weeks",
        },
        {
          id: "tailNumber",
          selected: false,
          text: "Flown this tail number before",
        },
        {
          id: "destinationAirport",
          selected: false,
          text: "Familiar with destination airport",
        },
        {
          id: "threeIn90Days",
          selected: false,
          text: "3 takeoffs/landings in last 90 days",
        },
        { id: "bFRIPCCurrent", selected: false, text: "BFR/IPC Current" },
        { id: "withCFI", selected: false, text: "Flying with CFI" },
      ],
      arropecDoc: [
        {
          id: "airworthinessCert",
          selected: false,
          text: "Airworthiness Certificate",
        },
        {
          id: "weightBalance",
          selected: false,
          text: "Official Weight and Balance",
        },
        {
          id: "registrationCert",
          selected: false,
          text: "Registration Certificate",
        },
        { id: "placards", selected: false, text: "Placards" },
        {
          id: "radioLicense",
          selected: false,
          text: "Radio Station License - flying outside US",
        },
        { id: "dataPlate", selected: false, text: "External Data Plate" },
        { id: "handbook", selected: false, text: "Operating Handbook" },
        { id: "compassCard", selected: false, text: "Compass Deviation Card" },
      ],
      aac1atesInspection: null,
      airworthinessDirectives: [
        { id: "list", selected: false, text: "List available at" },
        {
          id: "applicableADs",
          selected: false,
          text: "Applicable ADs and compliance listed in MX Summary",
        },
        {
          id: "verifyAD",
          selected: false,
          text: "Verify recurring AD currency",
        },
      ],
      inoperativeEquipment: [
        { id: "list", selected: false, text: "List Inoperative Equipment" },
        { id: "POH", selected: false, text: "Not Required by POH" },
        { id: "TCDS", selected: false, text: "Not Required by TCDS" },
        {
          id: "91.205etc",
          selected: false,
          text: "Not Required by 91.205, 91.207, etc",
        },
        { id: "AD", selected: false, text: "Not Required by AD" },
        {
          id: "deactivate",
          selected: false,
          text: "Deactivate / Remove / Placard / Report and make PIC Decision",
        },
      ],
      nwkraft: [
        { id: "NOTAMS", selected: false, text: "NOTAMS" },
        { id: "weather", selected: false, text: "Weather" },
        { id: "atcDelays", selected: false, text: "Known ATC Delays" },
        { id: "runwayLengths", selected: false, text: "Runway Lengths" },
        { id: "alternates", selected: false, text: "Alternates" },
        { id: "fuel", selected: false, text: "Fuel" },
        {
          id: "takeOffLandDis",
          selected: false,
          text: "Take Off & Landing Distances",
        },
      ],
      notams: "",
      weatherChart: [],
      forecast: "",
      stations: [],
      atcDelays: "",
      runwayLengths: [],
      alternatives: [],
      flights: [],
      externalFactors: [
        { id: "externalFactors", selected: false, text: "External Factors" },
        { id: "emotion", selected: false, text: "Emotion" },
        { id: "eating", selected: false, text: "Eating" },
      ],
    };
  },
  async created() {
    this.session_id = this.$route.query.session_id;
    this.getSession();
    this.getStudent();
    this.getAircraft();
    this.getAAV1ATES();
    this.getWeather();
    this.getStations();
    this.getRunwayLengths();
    this.getAlternatives();
    this.getFlights();
  },
  mounted() {
    this.$nextTick(() => {
      this.getDynamicWidth();
    });
    window.onload = this.getDynamicWidth;
    window.onresize = this.getDynamicWidth;
  },
  methods: {
    getSession() {
      if (!this.session_id) {
        this.session_id = 8;
      }
      this.session = {
        id: 8,
        name: "Flight 8",
        date: new Date("05/01/24"),
        description:
          "Lorem ipsum dolor sit amet,\n" +
          "consectetuer adipiscing elit, sed diam\n" +
          "nonummy nibh euismod tincidunt ut\n" +
          "laoreet dolore ",
        riskScore: 75,
        studentId: 1,
        aircraftId: 1,
        status: "Approved",
        galReq: 200,
      };
    },
    getStudent() {
      this.student = {
        id: 1,
        full_name: "Tyler Johnson",
        lastSessionId: 7,
        programId: 1,
        balance: 300,
      };
    },
    getAircraft() {
      this.aircraft = {
        id: 1,
        aircraftNumber: 55555,
        takeOffWeight: 1500,
        takeOffCG: 82,
        takeOffMoment: 200000,
        landingWeight: 1500,
        landingCG: 82,
        landingMoment: 200000,
        galOnBoard: 300,
      };
    },
    getAAV1ATES() {
      const randomDate = new Date("04/12/24");

      this.aac1atesInspection = [
        {
          id: "annual",
          selected: false,
          text: "Annual - 12 Cal Months",
          date: randomDate,
        },
        {
          id: "vor",
          selected: false,
          text: "VOR - 30 Days (IFR)",
          date: randomDate,
        },
        {
          id: "100hour",
          selected: false,
          text: "100 Hour - Every 100 Hours",
          date: randomDate,
        },
        {
          id: "altimeter",
          selected: false,
          text: "Altimeter - 24 Cal Months (IFR)",
          date: randomDate,
        },
        {
          id: "transponder",
          selected: false,
          text: "Transponder - 24 Cal Months",
          date: randomDate,
        },
        {
          id: "eltInspection",
          selected: false,
          text: "ELT Inspection - 12 Cal Months",
          date: randomDate,
        },
        {
          id: "eltBattery",
          selected: false,
          text: "ELT Battery Replacement",
          date: randomDate,
        },
        {
          id: "static",
          selected: false,
          text: "Static - 24 Cal Months (IFR)",
          date: randomDate,
        },
      ];
    },
    getWeather() {
      const today = new Date();
      today.setHours(17, 0, 0, 0);
      this.weatherChart = [
        {
          id: 0,
          location: "KFFZ",
          time: today,
          wind: 15,
          visibility: 5,
          weather: "VFR",
          sky: "Clear",
          temp: 70,
          dewPoint: 15,
          altimeter: 29.92,
        },
        {
          id: 1,
          location: "KFFZ",
          time: today,
          wind: 15,
          visibility: 5,
          weather: "VFR",
          sky: "Clear",
          temp: 70,
          dewPoint: 15,
          altimeter: 29.92,
        },
        {
          id: 2,
          location: "KFFZ",
          time: today,
          wind: 15,
          visibility: 5,
          weather: "VFR",
          sky: "Marginal Haze",
          temp: 70,
          dewPoint: 15,
          altimeter: 29.92,
        },
      ];
    },
    getStations() {
      this.stations = [
        {
          id: 0,
          name: "KFFZ",
          threeK: "1623+00",
          sixK: "1623+00",
          nineK: "1623+00",
          customElevations: [],
        },
      ];
    },
    getRunwayLengths() {
      this.runwayLengths = [
        {
          dep: "5,000",
          dest: "10,000",
        },
      ];
    },
    getAlternatives() {
      this.alternatives = [
        {
          name: "KPVU",
        },
      ];
    },
    getFlights() {
      this.flights = [
        {
          name: "Flight 1",
          dep: 5000,
          dest: 10000,
        },
      ];
    },
    addCustomAltitude() {
      this.stations.forEach((station) => {
        station.customElevations.push({
          elevation: "",
          value: "",
        });
      });
    },
    removeCustomAltitude(stationIndex, elevationIndex) {
      this.stations[stationIndex].customElevations.splice(elevationIndex, 1);
    },
    addRunwayLength() {
      this.runwayLengths.push({ dep: "", dest: "" });
    },
    removeRunwayLength(index) {
      this.runwayLengths.splice(index, 1);
    },
    addAlternative() {
      this.alternatives.push({ name: "" });
    },
    removeAlternative(index) {
      this.alternatives.splice(index, 1);
    },
    addFlight() {
      this.flights.push({
        name: "Flight " + (this.flights.length + 1),
        dep: "",
        dest: "",
      });
    },
    removeFlight(index) {
      this.flights.splice(index, 1);
    },
    calculateRiskColor(value) {
      if (value >= 0 && value < 12.5) {
        return "redRisk";
      } else if (value >= 12.5 && value < 37.5) {
        return "orangeRisk";
      } else if (value >= 37.5 && value < 62.5) {
        return "yellowRisk";
      } else if (value >= 62.5 && value < 87.5) {
        return "limeRisk";
      } else {
        return "greenRisk";
      }
    },
    insertCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    toggleItemState(item) {
      item.selected = !item.selected;
    },
    moveToNextPAVE() {
      let nextLetter = null;
      let nextBool = false;
      for (let letter of this.pave) {
        if (nextBool) {
          nextLetter = letter;
          letter.current = true;
          break;
        }
        if (letter.current) {
          nextBool = true;
          letter.current = false;
        }
      }
      if (!nextLetter) {
        alert("Risk Value Calculated");
      }
    },
    calculateDaysSince(date) {
      const today = new Date();
      const timeDiff = today - date;
      return Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    },
    changePave(letter) {
      for (let lett of this.pave) {
        lett.current = lett.letter === letter;
      }
    },
    getDynamicWidth() {
      const referenceDiv = document.getElementById("referenceDiv");
      const targetDiv = document.getElementById("targetDiv");
      const referenceWidth = referenceDiv.offsetWidth;

      targetDiv.style.left =
        40 + (referenceWidth - 80) * (this.session.riskScore / 100) + "px";
    },
  },
};
</script>
<style scoped>
h1,
h2,
h5 {
  margin: 0;
}
h1 {
  font-size: 56px;
  font-weight: bold;
}
.normalH1 {
  font-size: 28px;
}
h2 {
  font-weight: bold;
  margin-top: 20px;
}
h5 {
  color: grey;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
td,
tr {
  padding: 0;
  margin: 0;
  border: none;
}
a {
  color: black;
}
el-input {
  border: none;
  background-color: transparent;
  color: #3fc4e7;
}
.basicCard {
  margin: 0.5em 0.5em;
  padding: 0;
  border-color: transparent;
  border-radius: 3em;
  background-color: #f7f8f9;
}
.borderedBox {
  border: 1px black solid;
  padding: 5px;
}
.cardTitles {
  padding: 0;
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  color: black;
}
.lightGreyButton {
  margin: 1em;
  padding: 0.2em 1.5em;
  background-color: #8e9093;
  color: #e7e7e7;
  border-color: transparent;
  font-weight: lighter;
  font-size: 16px;
}
.navyButton {
  margin: 0 2em;
  padding: 0 1em;
  background-color: #1d1c4b;
  color: white;
  border-radius: 0.3em;
  border-color: transparent;
  letter-spacing: 0.15em;
  font-size: 14px;
}
.bottomLine {
  background-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0) 15%,
      rgba(256, 256, 256, 100) 15%
    ),
    linear-gradient(0.25turn, #ed2223, #dc9626, #cada2b, #78c042, #00aa4d);
}
.redRisk {
  color: #ed2223;
}
.orangeRisk {
  color: #dc9626;
}
.yellowRisk {
  color: #cada2b;
}
.limeRisk {
  color: #78c042;
}
.greenRisk {
  color: #00aa4d;
}
.align-items-center {
  display: flex;
  align-items: center;
}
.align-content-center {
  display: flex;
  align-content: center;
}
.text-center {
  text-align: center;
}
.customCard {
  width: 100%;
  background-color: white;
  border-radius: 2em;
  padding: 2em 3em;
}
.barLabels {
  font-size: 16px;
  color: black;
  margin: 0 -1em;
}
.docsButton {
  font-size: 16px;
  color: black;
  border: none;
  background-color: #f0f3f3;
  font-weight: bold;
}
.valueBoxes {
  font-size: 16px;
  color: black;
  background-color: #f0f3f3;
  padding: 10px 30px;
  border-radius: 0.25em;
  margin: 5px 0;
}
.floatRight {
  float: right;
}
.camera {
  font-size: 20px;
  padding: 0 10px;
}
.icon-red,
.icon-orange,
.icon-green,
.icon-grey,
.icon-invisible {
  font-size: 22px;
  padding: 1px 0 0 1px;
}
.icon-red {
  color: #dd2025;
}
.icon-orange {
  color: #f04f22;
}
.icon-green {
  color: #199c75;
}
.icon-grey {
  color: #b5b7b7;
}
.icon-invisible {
  color: transparent;
}
.greyBorder {
  padding: 0 1em;
  margin: 0;
  border: 2px solid #f0f3f3;
  height: 100%;
  display: flex;
  align-items: center;
}
.greyBackground {
  background-color: #f0f3f3;
}
.selectedLetter,
.paveLetter {
  margin: 20px;
  padding: 0;
  height: 60px;
  width: 60px;
  font-size: 40px;
  font-weight: bold;
  text-align: center;
  align-content: center;
}
.selectedLetter {
  color: black;
  background-color: #f0f3f3;
  cursor: not-allowed;
}
.paveLetter {
  color: #dedfdf;
  background-color: transparent;
  cursor: pointer;
}
.paveLetter:hover {
  color: black;
  background-color: #f0f3f3;
}
.riskLevel {
  position: absolute;
  margin: 0;
  padding: 0;
  z-index: 10;
  bottom: 103px;
}
.riskLevel h5 {
  color: black;
  margin: 0;
  padding: 0;
}
.riskLevel h2 {
  margin-top: -5px;
  transform: scale(1, 0.75);
}
.listItems {
  font-weight: bold;
  color: black;
  font-size: 16px;
}
.checkButton {
  align-self: center;
  margin: 0;
  padding: 0;
  width: 30px;
  height: 30px;
  background-color: #f7f8f9;
  border-color: #dedfdf;
  border-width: 2px;
}
.displayFlex {
  display: flex;
  align-items: center;
}
.custom-col-sm-1 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  -ms-flex: 0 0 4.166665%;
  flex: 0 0 4.166665%;
  max-width: 4.166665%;
}
textarea {
  border-color: transparent;
  background-color: #f0f3f3;
  font-size: 14px;
  color: black;
  border-radius: 6px;
  width: 100%;
}
button {
  border-style: solid;
}
.weather-chart {
  width: 100%;
  border-collapse: collapse;
}

.weather-chart th,
.weather-chart td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
}
.weather-chart .chart-header {
  background-color: #414041;
  color: white;
  text-align: left;
  padding: 2px 30px;
}

.weather-chart th {
  background-color: #ffffff;
  color: black;
  font-weight: normal;
  padding: 2px 10px;
}

.weather-chart td.highlight {
  background-color: #b3d6a6;
}

.weather-chart td {
  padding: 2px 10px;
  background-color: #e6e9e9;
}
.stationField {
  width: 100%;
  align-self: center;
  background-color: #f0f3f3;
  color: #aca7ac;
  border-radius: 6px;
  text-align: right;
  padding: 0 10px;
  margin: 0;
  font-weight: normal;
}
.position-absolute {
  position: absolute;
}

.top-left {
  top: -5px;
  left: -10px;
}

.listValues {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.listValues span {
  margin-left: 5px;
}

.remove-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.remove-icon {
  font-size: 16px;
  color: #dd2025;
}
</style>
